import React, { FC, ReactElement, useRef, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { StyleSheetManager } from 'styled-components'
import MainComponent from 'components/MainComponent'
// import DevTools from 'DevTools'
// import tenants from 'Constants/tenants'

const App: FC<MicroFrontendProps> = (microFrontendProps): ReactElement => {
  const [ref, setRef] = useState<HTMLDivElement | null>()
  const styleRef = useRef<any>()
  const [cssIsInjected, setCssIsInjected] = useState(false)

  if (styleRef.current) {
    styleRef.current.onload = () => {
      setCssIsInjected(true)
    }
    styleRef.current.onerror = () => {
      // if we don't have any css file (if you use styled components)
      setCssIsInjected(true)
    }
  }

  return (
    <div id='root' ref={(newRef) => setRef(newRef)}>
      <link
        ref={styleRef}
        rel='stylesheet'
        href={
          process.env.REACT_APP_DEPLOY_PATH
            ? process.env.REACT_APP_DEPLOY_PATH + '/static/css/main.css'
            : 'static/css/main.css'
        }
      />
      {ref && cssIsInjected && (
        <div id='app'>
          <StyleSheetManager target={ref}>
            <MainComponent {...microFrontendProps} />
          </StyleSheetManager>
        </div>
      )}
    </div>
  )
}
export default App
if (window.document.title === 'TA-Interaktiv Microfrontend') {
  const DevToolAppWrapper: FC = (): ReactElement => {
    const [isDarkmode, setIsDarkmode] = useState(false)
    const [showDevTools, setShowDevTools] = useState(false)
    // const [currentTenantKey, setCurrentTenantKey] =
    //   useState<TenantKey>('tagesanzeiger')
    return (
      // <DevTools
      //   setTenant={setCurrentTenantKey}
      //   setIsDarkmode={setIsDarkmode}
      //   isDarkmode={isDarkmode}
      //   currentTenantKey={currentTenantKey}
      // >
      <>
      <div id='dev-tools-container'>
      <div onClick={() => setShowDevTools(!showDevTools)}>
        Toggle Devtools
      </div>
      {showDevTools && (
        <div>
          <div>
            <span>Darkmode:</span>
            <input
              type='button'
              value={isDarkmode ? 'on' : 'off'}
              onClick={() => setIsDarkmode(!isDarkmode)}
            />
          </div>
          {process.env.REACT_APP_DEPLOY_PATH &&
            <a
              onClick={(e) => {
                e.preventDefault()
                navigator.clipboard.writeText(
                  process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js'
                )
              }}
              href={
                process.env.REACT_APP_DEPLOY_PATH + '/static/js/main.js'
              }
            >
              Copy path to JS 🔗
            </a>
          }
        </div>
      )}
    </div>

      <App
        tenant={{
          feedId: 2,
          key: 'tagesanzeiger',
          lang: 'de',
          name: 'Tages-Anzeiger',
        }}
        colorMode={isDarkmode ? 'dark' : 'light'}
        properties={{
          width: 'content',
          title: '2022 war der zweitwärmste Sommer seit Aufzeichnung',
          lead: 'Die Abbildung zeigt die Abweichung von der durchschnittlichen Sommertemperatur (Juni/Juli/August) in der Schweiz zum Referenzzeitraum 1961 bis 1990. Fünf der sechs wärmsten je gemessenen Sommer traten in den letzten zehn Jahren auf.',
          // caption:
          //   '* Tage an denen eine Höchsttemperatur von mindestens 30° erreicht wurde.',
          source: 'Grafik: pvo; Quelle: Meteo Schweiz',
          legendRanking: 'Die fünf wärmsten und kältesten Sommer seit Messbeginn'
        }}
      />
      </>
      // </DevTools>
    )
  }
  const root = createRoot(document.getElementById('root')!)
  root.render(
    <React.StrictMode>
      <DevToolAppWrapper />
    </React.StrictMode>
  )
}
